import { PageShell } from "@/components/PageShell";
import { Manifesto } from "@/components/Manifesto";
import { SilkBand } from "@/components/SilkBand";
import { StoryInvite } from "@/components/HomeSections";
import { useSeo } from "@/hooks/useSeo";

export default function ManifestoPage() {
  useSeo({
    title: "Il manifesto — DonnaImpresa | Rete, visibilità, sostegno, innovazione",
    description:
      "Il manifesto di DonnaImpresa: i valori della rete delle imprenditrici — rete, visibilità, sostegno e innovazione — e la visione che tiene insieme la community.",
    path: "/manifesto",
  });

  return (
    <PageShell testId="manifesto-page">
      <Manifesto />
      <SilkBand />
      <StoryInvite />
    </PageShell>
  );
}
